import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0AvatarPerson } from '@factorialco/f0-react'
import { Delete } from '@factorialco/f0-react/icons/app'

interface ApproverSelectionProps {
  onDelete: (strategyId: string) => void
  id: string
  label: string
  avatarUrl?: string
  avatarFirstName?: string
  avatarLastName?: string
  isDeactivated?: boolean
}

export const ApproverSelection = ({
  id,
  label,
  avatarUrl,
  avatarFirstName,
  avatarLastName,
  onDelete,
  isDeactivated = false,
}: ApproverSelectionProps) => {
  return (
    <Box
      flexDirection="row"
      gap="s8"
      alignItems="center"
      justifyContent="spaceBetween"
      padding="s8"
      borderRadius={{ all: 'abs008' }}
      className="hover:bg-f1-background-hover group"
    >
      <Box flexDirection="row" gap="s8" alignItems="center" width="full">
        <F0AvatarPerson
          firstName={avatarFirstName ?? ''}
          lastName={avatarLastName ?? ''}
          src={avatarUrl}
          size="sm"
          deactivated={isDeactivated}
        />
        <Text size="200" weight="medium" color={isDeactivated ? 'grey600' : undefined}>
          {label}
        </Text>
      </Box>
      <Delete
        width={20}
        height={20}
        onClick={() => onDelete(id)}
        className="opacity-0 group-hover:opacity-100 cursor-pointer text-f1-foreground-critical hover:text-f1-foreground-critical-hover"
      />
    </Box>
  )
}
